import pkg = require("../../package.json");
import { cleanURL } from "./Helper";
const appParam = {
    serverUrl: "https://" + pkg.domain + "/",
    apiPrefix: pkg.apiPrefix,
    subDomain: null as string,
};
function getServerUrl(): string {
    if (isLocal()) {
        return "http://localhost:8080/";
    }
    return appParam.serverUrl;
}
function getServerApiUrl(): string {
    return getServerUrl() + appParam.apiPrefix;
}
function isLocal(): boolean {
    const url = document.URL;
    return url.indexOf("localhost") > -1;
}
function getUserApiUrl(): string {
    const url = document.URL;
    if (isLocal()) {
        return "http://localhost/cgi-bin/API.cgi/";
    }
    return cleanURL(url) + "/cgi-bin/API.cgi/";
}

export default {
    getServerUrl,
    getServerApiUrl,
    getUserApiUrl,
    isLocal,
};
